import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTranslation } from '../../translations';
import LanguageToggle from './LanguageToggle';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { language } = useLanguage();
  const { t } = useTranslation(language);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (sessionStorage.getItem('session_expired')) {
      sessionStorage.removeItem('session_expired');
      setNotice(
        language === 'es'
          ? 'Tu sesión ha caducado. Por favor, inicia sesión de nuevo.'
          : 'Your session has expired. Please log in again.'
      );
    }
  }, [language]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(email, password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 flex items-center justify-center p-4">
      <div className="glass-card w-full max-w-2xl p-8">
        <div className="flex justify-end mb-4">
          <LanguageToggle />
        </div>
        
        <div className="text-center mb-8">
          <div className="flex justify-center mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_workout-central-9/artifacts/1boxowhf_logo%20btc.PNG" 
              alt="Bétera Training Center" 
              className="h-32 w-32 object-contain"
            />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Betera Training Center</h1>
          <p className="text-blue-200">{t('welcome_back')}</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {notice && (
            <div className="bg-amber-500/20 border border-amber-400 text-amber-100 px-4 py-3 rounded-lg" data-testid="session-expired-notice">
              {notice}
            </div>
          )}
          <div>
            <label className="block text-blue-200 text-sm font-medium mb-2">{t('email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-field"
              placeholder={t('email')}
              required
            />
          </div>

          <div>
            <label className="block text-blue-200 text-sm font-medium mb-2">{t('password')}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field"
              placeholder={t('password')}
              required
            />
          </div>

          {error && (
            <div className="bg-red-500/20 border border-red-400 text-red-200 px-4 py-3 rounded-lg">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full"
          >
            {loading ? '...' : t('sign_in')}
          </button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-blue-200">
            {t('dont_have_account')}{' '}
            <Link to="/register" className="text-blue-400 hover:text-blue-300 font-medium">
              {t('sign_up')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
